import { Box, Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import ItemCount from "../../../../../utils/ItemCount";
import DraftTable from "../DraftTable";
import SRATable from "../../SRATable";

const CustomerDepositDashboard = () => {
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const [activeTab, setActiveTab] = useState(
    localStorage.getItem("activeTab") || "PENDING"
  );
  const [isLoading, setIsLoading] = useState(true);
  const [sras, setSras] = useState();
  const [pendingCount, setPendingCount] = useState();
  const [approvedCount, setApprovedCount] = useState();
  const [rejectedCount, setRejectedCount] = useState();
  const [queryCount, setQueryCount] = useState();
  const [draftCount, setDraftCount] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    const getPendingCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/customer-deposit/count?username=${storedUser.username}&status=PENDING`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setPendingCount(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getPendingCount();

    const getApprovedCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/customer-deposit/count?username=${storedUser.username}&status=APPROVED`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setApprovedCount(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getApprovedCount();

    const getRejectedCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/customer-deposit/count?username=${storedUser.username}&status=REJECTED`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setRejectedCount(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getRejectedCount();

    const getQueryCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/customer-deposit/count?username=${storedUser.username}&status=QUERY`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setQueryCount(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getQueryCount();

    const getDraftCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/draft-customer-deposit/count?username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setDraftCount(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getDraftCount();
  }, [activeTab]);

  useEffect(() => {
    if (activeTab !== "DRAFTS") {
      const getSRAs = async () => {
        setSras();
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/customer-deposit?username=${storedUser.username}&status=${activeTab}`,
            { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
          );
          setSras(res.data);
        } catch (error) {
          console.log(error);
        } finally {
          setIsLoading(false);
        }
      };
      getSRAs();
    }
  }, [activeTab]);

  return (
    <Box sx={{ textAlign: "center" }}>
      {storedUser && storedUser.userRole.includes("BUYER") && (
        <Box sx={{ display: "flex", justifyContent: "end", gap: 3 }}>
          <Button
            className="btn-contained"
            sx={{ px: 5, width: 'auto !important' }}
            onClick={() => navigate("/approval/dashboard/create-customer-deposit")}
          >
            + New Customer Deposit
          </Button>
        </Box>
      )}

      <Box className="dashboard-container" sx={{ height: 400, width: "100%" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mb: 2,
            borderBottom: "1px solid #D1D1D1",
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: 1,
            }}
          >
            <Button
              className={`dashboard-btns ${
                activeTab === "PENDING" ? "active" : ""
              }`}
              onClick={() => {
                setActiveTab("PENDING");
                setIsLoading(true);
                localStorage.setItem("activeTab", "PENDING");
              }}
            >
              Submitted
              <ItemCount count={pendingCount} />
            </Button>
            <Button
              className={`dashboard-btns ${
                activeTab === "APPROVED" ? "active" : ""
              }`}
              onClick={() => {
                setActiveTab("APPROVED");
                setIsLoading(true);
                localStorage.setItem("activeTab", "APPROVED");
              }}
            >
              Approved
              <ItemCount count={approvedCount} />
            </Button>
            <Button
              className={`dashboard-btns ${
                activeTab === "REJECTED" ? "active" : ""
              }`}
              onClick={() => {
                setActiveTab("REJECTED");
                setIsLoading(true);
                localStorage.setItem("activeTab", "REJECTED");
              }}
            >
              Rejected
              <ItemCount count={rejectedCount} />
            </Button>
            <Button
              className={`dashboard-btns ${
                activeTab === "QUERY" ? "active" : ""
              }`}
              onClick={() => {
                setActiveTab("QUERY");
                setIsLoading(true);
                localStorage.setItem("activeTab", "QUERY");
              }}
            >
              Query
              <ItemCount count={queryCount} />
            </Button>
            <Button
              className={`dashboard-btns ${
                activeTab === "DRAFTS" ? "active" : ""
              }`}
              onClick={() => {
                setActiveTab("DRAFTS");
                setIsLoading(true);
                localStorage.setItem("activeTab", "DRAFTS");
              }}
            >
              My Drafts
              <ItemCount count={draftCount} />
            </Button>
          </Box>
        </Box>
        {activeTab === "DRAFTS" ? (
          <DraftTable />
        ) : (
          <SRATable sras={sras} activeTab={activeTab} isLoading={isLoading} />
        )}
      </Box>
    </Box>
  );
};

export default CustomerDepositDashboard;
